import { mutator } from 'satcheljs';
import { moveAssetArrow, pointerMove, startDraggingAssets, startPanning } from '../actions';
import getStore from '../store';

function resetHasDraggedFarEnough() {
    getStore().hasDraggedFarEnough = false;
}

mutator(startPanning, resetHasDraggedFarEnough);
mutator(startDraggingAssets, resetHasDraggedFarEnough);

mutator(pointerMove, ({ dx, dy }) => {
    if (!getStore().hasDraggedFarEnough) {
        const MIN_DRAG_THRESHOLD_PX = 20;
        const delta = Math.abs(dx) + Math.abs(dy);
        const hasDraggedFarEnough = delta > MIN_DRAG_THRESHOLD_PX;
        getStore().hasDraggedFarEnough = hasDraggedFarEnough;
    }
});

mutator(moveAssetArrow, () => {
    getStore().hasDraggedFarEnough = true;
});
